import { render, staticRenderFns } from "./EditQuestionAnswerCard.vue?vue&type=template&id=6310f96e&scoped=true"
import script from "./EditQuestionAnswerCard.vue?vue&type=script&lang=js"
export * from "./EditQuestionAnswerCard.vue?vue&type=script&lang=js"
import style0 from "./EditQuestionAnswerCard.vue?vue&type=style&index=0&id=6310f96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310f96e",
  null
  
)

export default component.exports